export const companyDesignRouters = {
  path: 'design/:qr_code',
  name: 'CompanyCertificateDesign',
  component: () => import('@/views/company/certificates/Design')
}
